import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Lesson } from '../../models/lesson.school.model';
import { LessonAdapter, LessonState } from '../reducers/lesson.school.reducer';
import { selectRouteParams } from './router.selector';

export const getLessonState = createFeatureSelector<LessonState>('lessons');
export const getIds = (state: LessonState) => state.ids;

export const {
  selectIds: getLessonIds,
  selectEntities: getLessonEntities,
  selectAll: getAllLessons,
  selectTotal: getTotalLessons,
} = LessonAdapter.getSelectors(getLessonState);

export const loading = createSelector(
  getLessonState,
  (lessonState: LessonState) => lessonState.loading,
);

export const inProgress = createSelector(
  getLessonState,
  (lessonState: LessonState) => lessonState.inProgress,
);

export const getLessonsBySelectedGroup = createSelector(
  getAllLessons,
  selectRouteParams,
  (allItems, { id }) => {
    if (allItems) {
      return allItems.filter((item) => {
        return item.groupId === id;
      });
    } else {
      return null;
    }
  },
);

export const getLessonsCountForGroup = (groupId?: string | null) =>
  createSelector(getAllLessons, (allItems) => {
    if (!groupId) return 0;
    return allItems.filter((item) => {
      return item.groupId === groupId;
    }).length;
  });

export const getLessonById = ({
  lessonId,
  groupId,
}: {
  lessonId: string | null;
  groupId?: string | null;
}) =>
  createSelector(getAllLessons, (allItems) => {
    if (!lessonId || !groupId) return null;

    return allItems.find((item) => {
      return item.groupId === groupId && item.id == lessonId;
    });
  });

export const getLessonsByGradeId = ({
  gradeId,
  groupId,
}: {
  gradeId?: string | null;
  groupId?: string | null;
}) =>
  createSelector(getAllLessons, (allItems) => {
    if (!gradeId || !groupId) return [];
    return allItems
      .filter((item) => {
        return item.groupId === groupId && item.gradeId === gradeId;
      })
      .sort(sortDescendingByCreatedDate);
  });

function sortDescendingByCreatedDate(a: Lesson, b: Lesson): number {
  return a.created! > b.created! ? -1 : a.created! < b.created! ? 1 : 0;
}
